import React, { useState } from "react";
import "./contact.css";
import { buildContactContext } from "../../../Utils/buildContext";
import {
  FiMapPin,
  FiMail,
  FiPhone,
  FiClock,
  FiSend,
} from "react-icons/fi";

import logo from "../../../assets/logo.png";

function Contact({ lang }) {
  const context = buildContactContext(lang);

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const [mailSentMsg, setMailSentMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMailSentMsg("");
    setErrorMsg("");

    if (
      !formData.fullName.trim() ||
      !formData.phone.trim() ||
      !formData.email.trim() ||
      !formData.subject.trim() ||
      !formData.message.trim()
    ) {
      setErrorMsg("Lütfen tüm alanları doldurun.");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Mail gönderilemedi.");
      }

      setMailSentMsg(context.is_Senden_msg);

      setFormData({
        fullName: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
      });

      setTimeout(() => {
        setMailSentMsg("");
      }, 3000);
    } catch (error) {
      setErrorMsg(error.message || "Bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-inner">
        <div className="contact-left">
          <h2>{context.title}</h2>
          <p>{context.text}</p>

          <div className="contact-logo">
            <img src={logo} alt="Company logo" />
          </div>
        </div>

        <div className="contact-mid">
          <div className="contact-info">
            <div className="info-row">
              <FiMapPin className="info-ic" />
              <div className="info-text">
                <h4>{context.address}</h4>
                <p>Güzelyalı mahallesi, elka sokak, no:7 Pendik/İstanbul</p>
              </div>
            </div>

            <div className="info-row">
              <FiMail className="info-ic" />
              <div className="info-text">
                <h4>{context.email}</h4>
                <p>info@ankormakina.com</p>
              </div>
            </div>

            <div className="info-row">
              <FiPhone className="info-ic" />
              <div className="info-text">
                <h4>{context.form_tel}</h4>
                <p>+90 534 988 14 30</p>
              </div>
            </div>
          </div>

          <div className="contact-extra">
            <div className="extra-row">
              <FiClock className="extra-ic" />
              <div className="extra-text">
                <h4>{context.hours_text}</h4>
                <p>{context.work_hours}: 09:00–17:00</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-right">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <input
                type="text"
                placeholder={context.form_fname}
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
              />
              <input
                type="tel"
                placeholder={context.form_tel}
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-row">
              <input
                type="email"
                placeholder={context.form_email}
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              <input
                type="text"
                placeholder={context.form_subject}
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </div>

            <textarea
              rows="6"
              placeholder={context.form_msg}
              name="message"
              value={formData.message}
              onChange={handleChange}
            />

            <div className="mail-message-wrapper">
              {mailSentMsg && (
                <p className="mail-sent-msg">
                  {mailSentMsg} <FiSend />
                </p>
              )}

              {errorMsg && <p className="mail-error-msg">{errorMsg}</p>}
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : context.buton}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;